import './SearchSuggestion.scss';
import { forwardRef } from 'react';
import Suggestion from '../suggestion/Suggestion';
import SearchSuggestionLabel from './SearchSuggestionLabel';

type Props = Readonly<{
  id?: string;
  href: string;
  label: string;
  ariaSelected: boolean;
  ariaDescribedBy?: string;
  tabIndex?: number;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  onClick?: () => void;
}>;

const SearchSuggestion = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      id,
      href,
      label,
      ariaSelected,
      ariaDescribedBy,
      tabIndex = -1,
      onKeyDown,
      onClick,
    }: Props,
    ref,
  ) => (
    <Suggestion
      ref={ref}
      id={id}
      href={href}
      ariaSelected={ariaSelected}
      ariaDescribedBy={ariaDescribedBy}
      tabIndex={tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}>
      <SearchSuggestionLabel label={label} />
    </Suggestion>
  ),
);

export default SearchSuggestion;
